// @flow

import React, { type ElementType } from 'react';
import classNames from 'classnames';
import { Monospace } from '../Text/Text';
import {
  type ThemeType,
  type InjectSheetProvidedProps
} from '../style/ThemeTypes';
import injectSheet from '../style/injectSheet';

const Style = (theme: ThemeType) => ({
  root: {
    ...theme.typography.monospace,
    display: 'inline',
    paddingLeft: '.5rem',
    paddingRight: '.5rem',
    border: `1px solid ${theme.colors.lightGrey}`,
    borderRadius: theme.variables.borderRadiusSmall
  }
});

type Props = InjectSheetProvidedProps & {
  /**
   * Component to be used as code renderer
   */
  component: ElementType
};

function MarkdownCodeSpan(props: Props) {
  const {
    classes,
    className: classNameProp,
    component: Component,
    theme,
    ...other
  } = props;
  const className = classNames(classes.root, classNameProp);

  return <Component {...{ ...other, className, component: Monospace }} />;
}

MarkdownCodeSpan.displayName = 'MarkdownCodeSpan';
MarkdownCodeSpan.defaultProps = {
  component: Monospace
};

export default injectSheet(Style)(MarkdownCodeSpan);
